export enum ModalType {
    /** @deprecated Use SeamlessUpgradeToPro instead */
    FullMigration = 'full_migration',
    SeamlessRegistration = 'seamless:after_registration',
    SeamlessCollaboration = 'seamless:by_collaboration_need',
    /** @deprecated UpgradeToPro modal will be rendered instead*/
    SeamlessProjectPartner = 'seamless:by_project_partner_need',
    HeadlessSeamlessMigration = 'seamless:headless_migration',
    SeamlessPayment = 'seamless:by_payment_need',
    SeamlessHourly = 'seamless:by_hourly_need',
    SeamlessLoyalty = 'seamless:by_loyalty_need',
    SeamlessMoneyBack = 'seamless:by_money_back_need',
    SeamlessCustomOfferMoneyBack = 'seamless:custom_offer_by_money_back',
    SeamlessCustomOfferRewardsProgram = 'seamless:custom_offer_by_rewards_program',
    SeamlessUpgradeToPro = 'seamless:upgrade_to_pro',
    LoyaltyUpgradeToPro = 'loyalty:upgrade_to_pro',
}

/**
 * @deprecated ViewType is deprecated and will be removed in future versions.
 */
export enum ViewType {
    Default = 'default',
    LowDetailsProfile = 'low_details_profile',
    AcquisitionFlowSeamlessModal = 'acquisition_flow_seamless_modal',
    AcquisitionFlowSeamlessModalSubscription = 'acquisition_flow_seamless_modal_subscription',
}
